import React, { useRef, useEffect, useState } from "react";
import { logoImg } from "../../constants/Images";
import { NavLink } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { doLogin } from "../../redux/actions/authAction";
import Blinking from "../../Loaders/Blinking";

export default function Login(props) {
  const { isAuthenticated, isLoginStarted, verifyEmailRes } = useSelector(
    (state) => state.authData
  );
  const dispatch = useDispatch();

  const [isPassword, setIsPassword] = useState(true);
  const [btnText, setBtnText] = useState("Show");

  let form = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = form.current;
    let formdata = {
      email: email.value,
      password: password.value,
    };
    dispatch(doLogin(formdata));
  };
  useEffect(() => {
    if (isAuthenticated) {
      if(props.location.from) {
        props.history.push(props.location.from.previousRoute.pathname);
        return
      }
      props.history.push("/customers");
    }
  }, [isAuthenticated]);

  const togglePasswordVisibility = () => {
    setIsPassword(!isPassword);
    const tempBtnText = isPassword ? "Hide" : "Show";
    setBtnText(tempBtnText);
  };
  return (
    <>
    {verifyEmailRes && verifyEmailRes.hasOwnProperty("id") && verifyEmailRes.id !== null ? (
        <Redirect to="/verify-email" />
      ) : null}
    <div className="container-fluid userservice_section">
      <div className="row align-items-center">
        <div className="col-sm-12 login_part">
          <div className="clearfix registeraArea loginArea">
            {/*             <div className="text-center mb-5">
              <a
                href="https://www.lambdatest.com/"
                target="_blank"
                className="logo"
              >
                <img src={logoImg} alt="LambdaTest" />
              </a>
            </div> */}
            <h1 className="form_title">LOGIN</h1>
            <form action="" className="form" ref={form} onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="user_form_label">Email address</label>
                <input
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  className="form-control"
                  required
                  name="email"
                />
              </div>
              <div className="form-group password-group">
                <label className="user_form_label">Password</label>
                <div className="input-group">
                  <input
                    type={isPassword ? "password" : "text"}
                    className="form-control"
                    required
                    minLength="6"
                    name="password"
                    id="userpassword"
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text password-group-text"
                      onClick={togglePasswordVisibility}
                    >
                      {btnText}
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-dark submit-btn">
                  Login
                  {isLoginStarted && (
                    <Blinking />
                  )}
                </button>
              </div>
              <div className="form-group">
                <label className="i_agree">
                  <input type="checkbox" />
                  <samp className="customcheckbox"></samp>
                  <span>Remember Me</span>
                </label>
                <p className="termsAndService bold">
                  <span className="clearfix">
                    <span className="float-left">
                      <Link to="/reset-password" className="ml-0">
                        Forgot Password?
                      </Link>
                    </span>
                    <span className="float-right">
                      No account? <Link to="/signup">Sign up</Link>
                    </span>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
